import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';

export default function AgeGate({ onVerify }) {
  return (
    <AnimatePresence>
      <div 
        className="fixed inset-0 z-[9999] bg-black/95 backdrop-blur-3xl flex items-center justify-center p-4"
        data-testid="age-gate-modal"
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          className="max-w-lg w-full mx-4 p-8 glassmorphism border-2 border-brand-lime/50 shadow-2xl"
        >
          <div className="text-center space-y-6">
            {/* Logo */}
            <div className="flex justify-center mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_luxhemp/artifacts/eosdqbph_310C9C52-31F3-41A9-B491-B40A0F9BDE7A_L0_001-1_6_2026%2C%2012_08_40%20AM%20%281%29.png"
                alt="High Achievers"
                className="h-28 md:h-36 w-auto"
              />
            </div>
            
            <div className="h-px bg-gradient-to-r from-transparent via-brand-lime to-transparent" />

            {/* Warning Icon */}
            <div className="flex justify-center">
              <div className="bg-brand-lime/10 p-4 rounded-full">
                <AlertTriangle className="w-12 h-12 text-brand-lime" />
              </div>
            </div>
            
            {/* Age Verification Text */}
            <div className="space-y-4">
              <h2 className="font-anton text-3xl md:text-4xl uppercase text-ha-ink">
                Age Verification Required
              </h2>
              
              <p className="font-body text-lg text-gray-300 leading-relaxed">
                You must be <span className="text-brand-lime font-bold text-2xl">21 years or older</span> to access this website.
              </p>
              
              <div className="bg-yellow-500/10 border border-yellow-500/30 rounded p-4 text-left">
                <p className="font-body text-sm text-gray-300">
                  <strong className="text-yellow-500">Important:</strong> This site offers hemp-derived products. By clicking "I AM 21 OR OLDER", you confirm that you are of legal age in your jurisdiction to view and purchase these products.
                </p>
              </div>

              <p className="font-accent text-xs uppercase tracking-wider text-gray-500">
                By entering, you agree to our{' '}
                <span className="text-brand-lime">Terms & Conditions</span> and{' '}
                <span className="text-brand-lime">Privacy Policy</span>
              </p>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col gap-3 pt-4">
              <Button
                onClick={onVerify}
                data-testid="age-verify-button"
                className="w-full bg-brand-lime text-black font-anton uppercase tracking-wider text-lg px-8 py-6 hover:bg-white hover:scale-105 transition-all shadow-lg shadow-brand-lime/20"
              >
                ✓ I AM 21 OR OLDER
              </Button>
              <Button
                onClick={() => window.location.href = 'https://www.google.com'}
                data-testid="age-decline-button"
                className="w-full bg-transparent border-2 border-red-500 text-ha-ink font-anton uppercase tracking-wider px-8 py-4 hover:bg-red-500/20"
              >
                ✗ I AM UNDER 21
              </Button>
            </div>

            {/* Legal Disclaimer */}
            <div className="border-t border-ha-ink/10 pt-4">
              <p className="text-xs text-gray-600 leading-relaxed">
                This website is intended for adults 21 years of age or older. By entering, you certify that you are of legal age to purchase hemp-derived products in your state/jurisdiction. High Achievers complies with all applicable federal and state laws. Products contain less than 0.3% THC.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}
